import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import { getNavigationItems } from '../reducer';
import Navigation from './Navigation';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var account = _ref.account,
    application = _ref.application;
  var baseUrl = _ref2.baseUrl,
    location = _ref2.location;
  return {
    navigationItems: getNavigationItems({
      baseUrl: baseUrl,
      application: application,
      account: account,
      location: location
    })
  };
};
export default withRouter(connect(mapStateToProps)(Navigation));